// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"c0bf1254","453":"03346f77","455":"6dd43026","828":"6cc522b3","977":"240addac"}[chunkId] + ".chunk.js";
};